/**
 * `activity` — le journal des actions de la galerie (base galerie, 4.1).
 */
import { z } from 'zod';
import { CHAMPS_DOCUMENT, idSchema, withAudit } from './commun.js';
export const ACTIONS_GALERIE = [
    'creation',
    'modification',
    'archivage',
    'publication',
    'emission',
    'consultation',
    'export',
    'suppression',
    'ESPACE_PARTAGE_AJOUTE',
    'ESPACE_PARTAGE_RETIRE',
    'ESPACE_CONSEIL_MODIFIE',
    'ESPACE_REGLAGES_MODIFIES',
    'ESPACE_ACCES_INVITE',
    'ESPACE_ACCES_RENVOYE',
    'ESPACE_ACCES_SUSPENDU',
    'ESPACE_ACCES_REACTIVE',
    'ESPACE_ACCES_REVOQUE',
    // La voix est un réglage de galerie : son édition reste un geste humain tracé.
    'IA_VOIX_MODIFIEE',
];
export const actionGalerieSchema = z.enum(ACTIONS_GALERIE);
export const OBJETS_GALERIE = [
    'artwork',
    'edition',
    'artist',
    'exhibition',
    'contact',
    'acces_externe',
    'espace_collectionneur',
    'inquiry',
    'reservation',
    'offer',
    'invoice',
    'payment',
    'movement',
    'document',
    'viewing_room',
    'catalogue_visite',
    'post',
    'page',
    'site',
    'template',
    'sequence',
    'tax_profile',
    'location',
    'media',
    'evenement',
    // Objet du journal pour les modifications du singleton de voix.
    'ia_voix',
];
export const objetGalerieSchema = z.enum(OBJETS_GALERIE);
export const activitySchema = withAudit(z.object({
    _id: idSchema,
    acteurId: idSchema,
    action: actionGalerieSchema,
    objet: z.object({ type: objetGalerieSchema, id: idSchema }),
    avant: z.record(z.string(), z.unknown()).optional(),
    apres: z.record(z.string(), z.unknown()).optional(),
    /** La raison, quand le geste en exige une (statut corrigé à la main, D13). */
    raison: z.string().optional(),
    date: z.date(),
}));
export const activityCreationSchema = activitySchema.omit(CHAMPS_DOCUMENT);
//# sourceMappingURL=activity.js.map